module.exports = __webpack_public_path__ + "src/assets/img/m44.3f6738bf.svg";